const UMLAUT_REPLACEMENTS = Object.freeze({
  ae: /[äÄ]/g,
  oe: /[öÖ]/g,
  ue: /[üÜ]/g,
  ss: /[ß]/g,
});

function transliterateGerman(value) {
  let output = String(value || '');

  output = output.replace(UMLAUT_REPLACEMENTS.ae, 'ae');
  output = output.replace(UMLAUT_REPLACEMENTS.oe, 'oe');
  output = output.replace(UMLAUT_REPLACEMENTS.ue, 'ue');
  output = output.replace(UMLAUT_REPLACEMENTS.ss, 'ss');

  return output;
}

export function slugifyHeading(input) {
  const withGermanTransliteration = transliterateGerman(input);

  return withGermanTransliteration
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
